import React,{useEffect} from "react";
import Banner from "../../utilities/Banner/Banner";
import { Container, Box, Button, Typography } from "@mui/material";
import { Constants } from "../Content";
import { getCrmDataSync } from "../../../Actions/CRMAction";
import { useState } from "react";
import ConfirmationBox from "../../ManageData/Popups/ConfirmationBox";
import Notification from "../../utilities/Notification/Notification";
import { Severity } from "../../utilities/Notification/NotificationContent";
import Loader from "../../utilities/Loader/Loader";
import { ManageSyncWrapper } from "./ManageSyncStyled";
import { isJsonString } from "../../../Helper/Helper";
import { LocalStorageKeys, PageName } from "../../QuoteRequest/Content";
import { useNavigate } from "react-router-dom";
import {UserRole} from '../../QuoteRequest/Content';
import { Congiguration } from "../../../Constants/AppConstants";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedUserDetails } from "../../../Actions/UserAction";
import { GET_LOGGED_USER_DETAILS } from "../../../ActionTypes/ActionTypes";
import { syncQuotes } from "../../../Actions/QuoteAction";
const ManageSync = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
  const [showSyncData, setShowSyncData] = useState(false);
  const [showQuoteSyncData, setShowQuoteSyncData] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  //let loggedUser = isJsonString(
  //  sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
  //)
  //  ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
  //  : null;
    const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
    const loggedUserLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)) : null;
    //const crmDataLocalStorage = isJsonString(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL)) : null;

    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
    //let crmData = useSelector((state) => state?.CRMReducer?.crmData);

    if (loggedUser !== undefined && Object.keys(loggedUser).length === 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {

        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        } else {
            //storing user login to reducer
            dispatch({
                type: GET_LOGGED_USER_DETAILS,
                payload: loggedUser,
            });
        }

    } else if (loggedUser !== undefined && Object.keys(loggedUser).length !== 0 && loggedUser.constructor === Object && loggedUserLocalStorage !== null) {
        loggedUser = loggedUserLocalStorage;
        if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
            dispatch(getLoggedUserDetails(useremail))
                .then((response) => {
                    loggedUser = response;
                    const jsonUserData = JSON.stringify(response);
                    sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
                    //storing user login to reducer
                    dispatch({
                        type: GET_LOGGED_USER_DETAILS,
                        payload: response,
                    });
                })
                .catch((error) => {
                    console.log(`userEmail : ${useremail} error : ${error}`);
                });
        }
    }

    useEffect(() => {
      window.scrollTo(0, 0);
      sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE,PageName.MANAGESYNCPAGE);
      if (loggedUser?.userRole[0]?.id !== UserRole.PRICINGTEAM && 
        loggedUser?.userRole[0]?.id !== UserRole.PRICINGMANAGER && 
        loggedUser?.userRole[0]?.id !== UserRole.PRICINGVP) {
        navigate("/pageNotfound", {state: {
          status: Congiguration.unauthorizedStatus,
      },});
        }
        document.title = "Manage Sync";
    }, []);
  const closeAddRole = () => {
    setShowSyncData(false);
  };
  const closeQuoteSyncDialog = () => {
    setShowQuoteSyncData(false);
  };
  const handleCloseNotification = () => {
    setShowNotification(false);
  };
  const handleDataSync = () => {
    setShowSyncData(false);
    setLoadingState(true);
    getCrmDataSync()
      .then((res) => {
        setLoadingState(false);
        setNotificationMessage(Constants.SUCCESSMESSAGE);
        setNotificationSeverity(Severity.SUCCESS);
        setShowNotification(true);
        console.log(res.data, "res");
      })
      .catch((err) => {
        setLoadingState(false);

        setNotificationMessage(Constants.ERRORMESSAGE);
        setNotificationSeverity(Severity.WARNING);
        setShowNotification(true);
        console.log(err, "err");
      });
  };

  const handleQuoteDataSync = () => {
    setShowQuoteSyncData(false);
    setLoadingState(true);
    const userId = loggedUser?.user?.id || undefined;
    dispatch(syncQuotes(userId))
      .then((res) => {
        setLoadingState(false);
        setNotificationMessage(Constants.QUOTESYNCSUCCESSMESSAGE);
        setNotificationSeverity(Severity.SUCCESS);
        setShowNotification(true);
        console.log(res.data, "res");
      })
      .catch((err) => {
        setLoadingState(false);

        setNotificationMessage(Constants.ERRORMESSAGE);
        setNotificationSeverity(Severity.WARNING);
        setShowNotification(true);
        console.log(err, "err");
      });
  };

  return (
    <div>
      <ManageSyncWrapper>
        <Banner
          Heading={Constants.BANNER_HEADING}
          Paragraph={Constants.BANNER_PARAGRAPH}
          showBreadcrumb={true}
          breadcrumbName={Constants.BREADCRUMB_NAME}
        />
        <Container maxWidth="xl">
          <Box className="usersTable">
            <div className="buttonTab">
              <Typography>{Constants.PAGEMESSAGE}</Typography>
              <Button
                variant="contained"
                className="manageSyncButton"
                onClick={() => setShowSyncData(true)}
              >
                {Constants.MANUALSYNC}
              </Button>
            </div>
          </Box>
          <Box className="usersTable">
            <div className="buttonTab">
              <Typography>{Constants.QUOTESYNCMESSAGE}</Typography>
              <Button
                variant="contained"
                className="manageSyncButton"
                onClick={() => setShowQuoteSyncData(true)}
              >
                {Constants.MANUALQUOTESSYNC}
              </Button>
            </div>
          </Box>
        </Container>
      </ManageSyncWrapper>
      {showSyncData && (
        <ConfirmationBox
          show={showSyncData}
          title={Constants.CONFIRM}
          message={Constants.SYNCCONFIRMATION}
          handleConfirmClick={handleDataSync}
          handleCancelClick={closeAddRole}
        />
      )}
      {showQuoteSyncData && (
        <ConfirmationBox
          show={showQuoteSyncData}
          title={Constants.CONFIRM}
          message={Constants.QUOTESYNCCONFIRMATION}
          handleConfirmClick={handleQuoteDataSync}
          handleCancelClick={closeQuoteSyncDialog}
        />
      )}
      {showNotification && (
        <Notification
          onClose={handleCloseNotification}
          open={showNotification}
          message={notificationMessage}
          severity={notificationSeverity}
        />
      )}
      {loadingState && <Loader open={loadingState} />}
    </div>
  );
};

export default ManageSync;
